import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Link, useNavigate } from 'react-router-dom'


function Profile() {

    document.title = "Profile | Lehumo";

    //User navigate to redirect to login page
    const navigate = useNavigate();

    const handleLogout = () => {
        // Clear cache logic
        //window.localStorage.clear();

        navigate('/Login');
    };

    return (
        <>

            <Container>
                <>
                    <UserDetails>
                        <h2>Thato Kgomo</h2>
                    </UserDetails >

                    <Box><br />

                        <Row>

                            <SingleBox>

                                <Link to={`/Wallets`}>
                                    <Icon>
                                        <center>
                                            <li className='fa fa-wallet'></li>
                                        </center>
                                    </Icon></Link>

                                <h2><Link to={`/Portfolio`}>Portfolio</Link></h2>

                            </SingleBox>

                            <SingleBox>

                                <Link to="/Settings">
                                    <Icon>
                                        <center>
                                            <li className='fa fa-cog'></li>
                                        </center>
                                    </Icon></Link>

                                <h2><Link to="/Settings">Settings</Link></h2>

                            </SingleBox>

                        </Row>

                        <Row>

                            <SingleBox>

                                <Link to="/Help">
                                    <Icon>
                                        <center>
                                            <li className='fa fa-question'></li>
                                        </center>
                                    </Icon></Link>

                                <h2><Link to="/Help">Help</Link></h2>

                            </SingleBox>


                            <SingleBox>

                                <Icon onClick={handleLogout}>
                                    <center>
                                        <li className='fa fa-sign-out'></li>
                                    </center>
                                </Icon>

                                <h2 onClick={handleLogout}>Sign Out</h2>

                            </SingleBox>

                        </Row><br />

                    </Box>
                </>

            </Container >
        </>
    )
}

export default Profile

const Container = styled.div`
    margin-bottom: 20px;
    
`

const UserDetails = styled.div`
    height: 25vh;
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    margin-top: 70px;
    background: var(--primary);
    border-bottom-left-radius: 30%;
    border-bottom-right-radius: 30%;


    h2 {
        text-transform: uppercase;
        font-size: 48px;
        font-weight: 600;
        color: #fff;
        text-align: center;
    }


    @media (max-width: 768px) {

        height: 20vh;

        h2 {
            font-size: 24px;
        }

    }

`

const Box = styled.div`
    background-color: #fff;
    width: 60%;
    height: 100%;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin: 0 auto;
    margin-top: 20px;
    align-items: center;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        width: 95%;
        margin-top: 20px;
        height: auto;

    }

`

const Row = styled.div`

    margin: 0 auto;
    align-items: center;
    justify-content: center;
    width: 800px;
    display: flex;
    
    @media (max-width: 768px) {
        display: block;
        width: 300px;
    }
`

const SingleBox = styled.div`

    display: flex;
    width: 80%;
    height: 80px;
    background-color: #efeded;
    justify-content: left;
    align-items: center;
    border-radius: 5px;
    margin: 10px 10px;

    h2 {
        text-transform: uppercase;
        color: #333;
        margin-left: 20px;
        font-size: 20px;
    }

    @media (max-width: 768px) {

        width: 100%;

        h2 {
            font-size: 20px;
        }
    }

`

const Icon = styled.div`

    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-left: 15px;
    background-color: var(--primary);
  

    li {
        margin-top: 15px;
        font-size: 20px;
        color: #fff;
    }

`